import React from "react";

const CameraSettings = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="14" height="10.64" viewBox="0 0 14 10.64">
			<path
				id="icon-camera-settings"
				d="M2.52,6A2.523,2.523,0,0,0,0,8.52v5.6a2.523,2.523,0,0,0,2.52,2.52h5.6a2.522,2.522,0,0,0,2.52-2.52V8.52A2.523,2.523,0,0,0,8.12,6ZM13.729,7.68a.251.251,0,0,0-.131.026L11.2,8.9v4.83l2.4,1.2a.266.266,0,0,0,.122.026.291.291,0,0,0,.149-.044A.274.274,0,0,0,14,14.68V7.96a.274.274,0,0,0-.131-.236A.309.309,0,0,0,13.729,7.68Zm-9.135.28H5.968a.155.155,0,0,1,.166.14l.079.866a4.465,4.465,0,0,1,.621.367l.814-.367a.147.147,0,0,1,.219.061l.7,1.2a.178.178,0,0,1-.053.227l-.7.5a1.79,1.79,0,0,1,.026.368,1.716,1.716,0,0,1-.026.368l.779.5a.156.156,0,0,1,.061.227l-.7,1.2a.225.225,0,0,1-.227.061l-.814-.367a1.974,1.974,0,0,1-.612.367l-.087.866a.155.155,0,0,1-.166.14H4.673a.155.155,0,0,1-.166-.14l-.079-.866a4.575,4.575,0,0,1-.621-.367l-.814.367a.147.147,0,0,1-.219-.061l-.7-1.2a.178.178,0,0,1,.053-.227l.7-.5A1.716,1.716,0,0,1,2.8,11.32a.9.9,0,0,0-.052-.368l-.7-.5a.156.156,0,0,1-.061-.227l.7-1.2a.225.225,0,0,1,.227-.061l.814.367a1.974,1.974,0,0,1,.612-.367L4.427,8.1A.155.155,0,0,1,4.594,7.96ZM5.32,9.92a1.4,1.4,0,1,0,1.4,1.4A1.386,1.386,0,0,0,5.32,9.92Z"
				transform="translate(0 -6)"
				fill="#fff"
				opacity="0.5"
			/>
		</svg>
	);
};

export default CameraSettings;
